import React, { useEffect, useState } from "react";
import "../assets/css/BlogsSection.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const BlogsSection = () => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    fetchLatestBlogs();
  }, []);

  const fetchLatestBlogs = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/blogs`);

      // Sort by createdAt (latest first)
      const sorted = response.data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      // Pick latest 4
      setBlogs(sorted.slice(0, 4));
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  // Animation logic
  useEffect(() => {
    const cards = document.querySelectorAll(".blog-card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            entry.target.style.animationDelay = `${index * 0.2}s`;
            entry.target.classList.add("fade-up");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, [blogs]); // run animation again when blogs load

  return (
    <section className="blogs-section">
      <div className="blogs-header">
        <div>
          <h2 className="blogs-title">
            Our <span>Blogs</span>
          </h2>
          <p className="blogs-subtitle">
            Stay up to date with the latest trends and news in the world.
          </p>
        </div>

        <button className="blogs-btn" onClick={() => navigate("/blogs")}>
          Go to Blogs →
        </button>
      </div>

      <div className="blogs-grid">
        {blogs.map((blog) => (
          <div
            key={blog._id}
            className="blog-card"
            onClick={() => navigate(`/blog/${blog._id}`)}
            style={{ cursor: "pointer" }}
          >
            <div className="blog-image">
              <img
                src={`${process.env.REACT_APP_IMAGE_BASE_URL}/uploads/${blog.image}`}
                alt={blog.title}
                loading="lazy"
              />
            </div>
            <h3 className="blog-title">{blog.title}</h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BlogsSection;
